import * as Sentry from "@sentry/vue";
import Toaster from "v-toaster";
import Vue from "vue";
import Tooltip from "vue-directive-tooltip";
import i18n from "./i18n";

import "v-toaster/dist/v-toaster.css";
import interceptors from "./shared/interceptors";
import { addStyleTag, changeFavIcon, getEnvironment } from "./shared/utilities";

import App from "./App.vue";

const env = getEnvironment(); //get env

if (!window.__APP_NAME__) {
  // set default app to apollo
  // if server doesnt set
  window.__APP_NAME__ = "apollo";
}

const configs = {
  apollo: {
    name: "Adspert",
    landingPage: "//adspert.net",
    loginUrl: `${location.origin}/monitor`,
    ssoUrl: `${location.origin}/auth/login`,
    settingsUrl: `${location.origin}/settings/user/profile`,
    signupUrl: `${location.origin}/signup/reset`,
    favicon:
      "//d1npkqd03tmfjl.cloudfront.net/userservice-20191030-14222800001084/favicon_default.ico",
    links: {
      en: [
        {
          name: "Privacy policy",
          url: "//www.adspert.net/tc-privacy",
        },
        { name: "Terms & Conditions", url: "//www.adspert.net/tc-privacy" },
        { name: "Imprint", url: "//www.adspert.net/imprint" },
      ],
      de: [
        {
          name: "Datenschutzerklärung",
          url: "//www.adspert.net/tc-privacy/?lang=de/",
        },
        { name: "AGB", url: "//www.adspert.net/tc-privacy/?lang=de/" },
        { name: "Impressum", url: "//www.adspert.net/imprint/?lang=de/" },
      ],
      zh: [
        {
          name: "隐私政策",
          url: "//www.adspert.net/en/privacy/",
        },
        { name: "条件与条款", url: "//www.adspert.net/tc-privacy/" },
        { name: "版本说明", url: "//www.adspert.net/en/imprint/" },
      ],
    },
    css: {
      font: '"Proxima Nova", Helvetica, Arial, sans-serif',
      fontPath:
        "//adspert-web-assets.s3.eu-central-1.amazonaws.com/adspert/fonts/proxima-nova/font-styles.css",
      primaryText: "#009EE0",
      primaryBg: "#009EE0",
      secondaryText: "#005A8C",
      secondaryBg: "#005A8C",
      mirakl: "#1563A3",
      blackText: "#000",
      whiteText: "#fff",
      lightGreyText: "#909BAB",
      greyText: "#5D6C7F",
      darkGreyText: "#232B3B",
      customStyles: ".logo img{height: 20px !important;}",
    },
  },
};

window.__config__ = configs[window.__APP_NAME__];
document.body.className = window.__APP_NAME__;
//add CSS
addStyleTag(window.__config__.css);
// add favicon
changeFavIcon(window.__config__.favicon);
// page Title
document.title = window.__config__.name;

// vue init
Vue.config.productionTip = false;
Vue.directive("visible", function (el, binding) {
  el.style.visibility = !!binding.value ? "visible" : "hidden";
});

Sentry.init({
  Vue,
  dsn: "https://05b65fbef09b715e6ea8cecb19bf8299@o4507922024038400.ingest.de.sentry.io/4507932598468688",
  environment: env,
  release: process.env.VUE_APP_VERSION,
  enabled: env === "development",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1,
  tracePropagationTargets: ["*"],
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1,
});
Sentry.setTag("app", "Portal");

// init tooltip
Vue.use(Tooltip);
// init toaster
Vue.use(Toaster, { timeout: 5000 });

// init interceptor
interceptors();

new Vue({
  i18n,
  render: (h) => h(App),
}).$mount("#app");
